import { render } from "./ProductSelectionBrandsSelection.vue?vue&type=template&id=64aacfa5&scoped=true&ts=true"
import script from "./ProductSelectionBrandsSelection.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionBrandsSelection.vue?vue&type=script&lang=ts"

import "./ProductSelectionBrandsSelection.vue?vue&type=style&index=0&id=64aacfa5&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64aacfa5"]])

export default __exports__